const { h, render, Component } = require('preact');

class ResponseTimeView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div class="response-time-section">
        <span class="icon-now"></span>
        <span class="estimated-response-time">
          {I18n.translate("js.modules.web_2018.estimated_response_time")}: <span class="time-in-bold">{this.props.responseTimeString}</span>
        </span>
      </div>
    )
  }
}

module.exports = ResponseTimeView
